import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/hero001-1920x1080.jpg"
          alt="African business leadership"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D1F14]/90 via-[#0D1F14]/70 to-[#0D1F14]/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 w-full pt-24 pb-20">
        <div className="max-w-3xl">
          <div
            className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-6">
              Harambee Global Ventures &mdash; A 7 Hills Development Group Company
            </span>
          </div>

          <h1
            className={`font-['Cormorant_Garamond'] text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 transition-all duration-700 delay-100 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            Reimagining Intergenerational
            <span className="block text-[#C9A961] italic">Wealth Creation</span>
            Across the African Diaspora
          </h1>

          <p
            className={`text-white/75 text-lg md:text-xl leading-relaxed max-w-2xl mb-10 font-['Inter'] font-light transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            A trusted platform for financial education, cross-border advisory, and long-term wealth-building &mdash; connecting vision with opportunity for the African Diaspora and emerging investors worldwide.
          </p>

          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-300 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <Link
              to="/trading-academy"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md bg-[#C9A961] text-[#1A2B1F] font-semibold text-sm hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply for the Trading Academy
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-md border border-white/40 text-white font-medium text-sm hover:border-[#C9A961] hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Consultation
            </Link>
          </div>

          {/* Stats */}
          <div
            className={`mt-16 flex flex-wrap gap-10 transition-all duration-700 delay-500 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            {[
              { value: "7+", label: "Service Pillars" },
              { value: "3", label: "Continents Served" },
              { value: "Nairobi", label: "East Africa Hub" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#C9A961]">{stat.value}</div>
                <div className="text-white/50 text-xs uppercase tracking-widest mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-white/30" />
        <i className="ri-arrow-down-line text-white/40 text-sm" />
      </div>
    </section>
  );
}
